import { Link } from "react-router-dom";
import KtrlLayout from "../../components/ktrl/KtrlLayout";

const posts = [
  {
    date: "27. mars 2026",
    category: "Produktfilosofi",
    title: "Hvorfor vi bygget Klaw KTRL slik vi bygget det",
    excerpt: "De fleste AI-chatboter frustrer kundene. Vi ville bygge noe annerledes.",
    to: "/blogg/klaw-ktrl-filosofi",
  },
];

const KtrlBloggPage = () => {
  return (
    <KtrlLayout>
      <section className="max-w-5xl mx-auto px-6 md:px-12 py-20 md:py-28">
        <span className="inline-block text-xs font-semibold uppercase tracking-widest text-indigo-600 mb-3">
          Blogg
        </span>
        <h1 className="text-3xl md:text-5xl font-bold tracking-tight text-slate-900 mb-12">Blogg</h1>

        <div className="flex flex-col gap-8">
          {posts.map((post) => (
            <article key={post.to} className="border-b border-slate-200 pb-8">
              <div className="text-sm text-slate-500 mb-2">
                {post.date} · {post.category}
              </div>
              <h2 className="text-xl font-bold text-slate-900 mb-2">
                <Link to={post.to} className="hover:text-indigo-600 transition-colors">
                  {post.title}
                </Link>
              </h2>
              <p className="text-slate-600 leading-relaxed mb-3">{post.excerpt}</p>
              <Link
                to={post.to}
                className="text-sm font-medium text-indigo-600 hover:underline"
              >
                Les innlegget →
              </Link>
            </article>
          ))}
        </div>
      </section>
    </KtrlLayout>
  );
};

export default KtrlBloggPage;
